import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=e61c10ac&scoped=true&"
import script from "./Poll.vue?vue&type=script&lang=ts&"
export * from "./Poll.vue?vue&type=script&lang=ts&"
import style0 from "./Poll.vue?vue&type=style&index=0&id=e61c10ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61c10ac",
  null
  
)

export default component.exports